import DialogContent from "@mui/material/DialogContent";
import { darken, lighten } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(DialogContent)(({ theme }) => ({
  background: theme.palette.commonground.main,
  color: theme.palette.commonground.contrastText,
  WebkitOverflowScrolling: "touch", // Add iOS momentum scrolling.
  padding: theme.spacing(2),
  paddingTop: theme.spacing(1),
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    width: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  "&:hover::-webkit-scrollbar": {
    width: theme.spacing(2),
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: theme.spacing(1),
    backgroundColor: darken(theme.palette.commonground.main, 0.2),
    backgroundClip: "content-box",
    margin: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    opacity: "0.5",
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  "&:hover::-webkit-scrollbar-thumb": {
    backgroundColor: lighten(theme.palette.secondary.main, 0.2),
  },
}));

const OmniDialogContent = props => {
  const { children, ...other } = props;
  return (
    <CustomizedComponent dividers {...other}>
      {children}
    </CustomizedComponent>
  );
};

export default OmniDialogContent;
